import React,{Component} from "react";
import { Container, Row,} from "shards-react";
import PageTitle from "../common/PageTitle";
import ViewTimeTable from './ViewTimeTable';
import AddTimeTable from './AddTimeTable';
import { toast } from 'react-toastify';
import firebase from '../firebase';
import ConfirmModal from '../ConfirmModal';
import Days from './Days';
import { Redirect } from 'react-router';

export default class TimeTable extends Component{

  constructor(props) {
    super(props);
  
    this.state = {
      add_homework : false,
      day_selected: undefined,
      
      showAddModal : false,

      class_list:[],
      subject_list:[],
      faculty_list:[],

      loading:false,
      table_data :[],
      time_table_data:[],
      current_data_class:undefined,

      selected_class:null, //this must not be as same current_data_class
      got_subjects:false,
      got_faculty:false,

      showConfirmModal:false,
      
      delete_data:{
        id:undefined,
        class:undefined,
        day:undefined
      },

      logged_in:false,
      
    };

    this.ShowViewHomeWork = this.ShowViewHomeWork.bind(this);
    this.ShowAddHomeWork  = this.ShowAddHomeWork.bind(this);
    this.get_class_list  = this.get_class_list.bind(this);
    this.get_subjects_list = this.get_subjects_list.bind(this);
    this.prepare_for_add = this.prepare_for_add.bind(this);
    this.return_selected_day = this.return_selected_day.bind(this);
    this.set_class = this.set_class.bind(this);
    this.return_selected_class = this.return_selected_class.bind(this);
    this.set_day = this.set_day.bind(this);
    this.get_timetable_data = this.get_timetable_data.bind(this);
    this.sort_data_by_time = this.sort_data_by_time.bind(this);
    this.setConfirmModalVisibility = this.setConfirmModalVisibility.bind(this);
    this.delete_data = this.delete_data.bind(this);
    this.askdeleteconfirm = this.askdeleteconfirm.bind(this);
  }


  get_class_list = ()=>{
      var that = this;
      this.setState({loading:true});
      firebase.firestore().collection('ClassList').doc('list').get().then(function(doc){
          var class_list = doc.data().classes;
          class_list.shift();  //removes first element in array
          that.setState({loading:false,class_list:class_list});
      }).catch(function(err){
          that.setState({loading:false});
          toast('Unable to get class list !', {containerId: 'A'});
      })
  }

   get_subjects_list = ()=>{
    if(this.state.got_subjects){
        return;
    }
    var that = this;
    this.setState({loading:true});
    firebase.firestore().collection('Subject').doc('list').get().then(function(doc){
        if(doc.exists){
            that.setState({subject_list:doc.data().list,loading:false,got_subjects:true});
        }
        else{
          that.setState({loading:false});
        }

    }).catch(function(err){
           toast('Unable to get subjects list', {containerId: 'A'});
          that.setState({loading:false});
      })
  }


  get_faculty_list = ()=>{
    if(this.state.got_faculty){
        return;
    }
    var that = this;
    this.setState({loading:true});
    firebase.firestore().collection('Faculty').get().then(function(snapshot){
          var data = [];
          snapshot.forEach(function(doc){
              data.push(doc.data());
          })

          that.setState({faculty_list:data,loading:false,got_faculty:true});
          console.log(data);

    }).catch(function(err){
           toast('Unable to get subjects list', {containerId: 'A'});
          that.setState({loading:false});
      })
  }

  prepare_for_add=()=>{
      this.get_subjects_list();
      this.get_faculty_list();
  }

  return_selected_day = () =>{
    return (this.state.day_selected);
  }

  return_selected_class = () =>{
    return (this.state.selected_class)
  }

  set_class=(value)=>{
    this.setState({selected_class:value},this.get_timetable_data);
  }

  set_day = (value)=>{
      this.setState({day_selected:value},this.get_timetable_data);
  }


  getPickerValue = value => {
      console.log(value);
  };

  ShowViewHomeWork = () =>{
    this.setState({add_homework:false});
  }

  ShowAddHomeWork = () =>{
    this.setState({add_homework:true});
  }

  componentDidMount(){
      this.get_class_list();
  }


  sort_data_by_time=(times)=>{
    

    times.sort(function (a, b) {
        return new Date('1970/01/01 ' + a.start_time) - new Date('1970/01/01 ' + b.start_time);
    });
    
    return (times);
  }

  get_timetable_data = () =>{

    var that = this;
    var class_name = this.state.selected_class;
    var day = this.state.day_selected;

    if(class_name === this.state.current_data_class){
      var sorted_data = this.sort_data_by_time(this.state.time_table_data[day]);
      this.setState({table_data:sorted_data});
      return;
    }

    if(class_name===null){
      return;
    }

    this.setState({loading:true,current_data_class:undefined,time_table_data:[],table_data:[]});

    firebase.firestore().collection('TimeTable').doc(class_name).get().then(function(doc){
        var data = doc.data();
        var sorted_data = that.sort_data_by_time(data[day]);
        console.log(sorted_data);
        that.setState({table_data:sorted_data,time_table_data:data,current_data_class:doc.id,loading:false});
        
    }).catch(function(err){
        console.log(err);
        that.setState({loading:false});
    })

  }

   setConfirmModalVisibility =(data)=>{
      if(data==="close"){
        this.setState({showConfirmModal:false});
      }
      else{
          this.setState({showConfirmModal:true});
      }
  }

  askdeleteconfirm = (data)=>{
      this.setState({delete_data:data,showConfirmModal:true});
  }


  delete_data = ()=>{
      
      var delete_data = this.state.delete_data;
      delete_data['day'] = this.return_selected_day();

      if(delete_data.id===undefined || delete_data.class===undefined || delete_data.day===undefined){
              toast('Insufficient Details !', {containerId: 'A'});
              return;
      } 
      var that = this;
        var func_ref = firebase.functions().httpsCallable('RemoveTimeTable');
        this.setState({loading:true,showConfirmModal:false});
       func_ref(delete_data).then(function(result) {
                  // Read result of the Cloud Function.
                  var data = result.data;
                  console.log(data);
                  if(data.status==="success"){
                        console.log("Document succesfully deleted!");
                        toast('Deleted Successfully !', {containerId: 'A'});
                   }
                  else{
                        toast(data.error.message, {containerId: 'A'});
                        console.log(data.error.message);
                  }
                  that.setState({loading:false,current_data_class:undefined},that.get_timetable_data); //setting current data class to undefined to fetch new data


        }).catch(function(error) {
                  // Getting the Error details.
                  //var code = error.code;
                  var message = error.message;
                  //var details = error.details;
                  // ...
                  console.log(error);
                  that.setState({loading:false});
                  toast(message, {containerId: 'A'});
        });

  }

   componentWillMount(){
    var that = this;
    var user = firebase.auth().currentUser;

      if (user) {
            // User is signed in.
            this.setState({logged_in:true});
      } else {
          // No user is signed in.
          this.setState({logged_in:false});
      }

  }



		render(){

    if(this.state.logged_in){
        //do nothing
    }
    else{
      return <Redirect push to="/login" />;
    }

			return (
					<Container fluid className="main-content-container px-4">

						 {/* Page Header */}
    					<Row noGutters className="page-header py-4">
      									<PageTitle sm="6" title="TimeTable" subtitle="Class" className="text-sm-left" />
    					</Row>

              <Days update_day={this.set_day} />


              
        			   { 
                  <ViewTimeTable add_timetable={()=>{this.setState({showAddModal:true},this.prepare_for_add)}} 
                                  loading={this.state.loading} 
                                  class_list={this.state.class_list}
                                  set_class={this.set_class}
                                  table_data={this.state.table_data}
                                  askdelete ={this.askdeleteconfirm}
                      /> 
                  }

                  
              
             

              <AddTimeTable show={this.state.showAddModal}  
                            handleClose={()=>{this.setState({showAddModal:false})}}  
                            subject_list={this.state.subject_list}
                            faculty_list={this.state.faculty_list}
                            loading={this.state.loading}
                            get_selected_day = {this.return_selected_day}
                            get_selected_class={this.return_selected_class}

                /> 


           <ConfirmModal
            show={this.state.showConfirmModal}
            onHide={() =>this.setConfirmModalVisibility('close')}
            handleClose={() =>this.setConfirmModalVisibility('close')}
            onAccept={()=>this.delete_data()}
            message={"Are you Sure?"}
          />
              			
					</Container>

			)
		}

}


